<template>
  <div>
  <section style="padding: 30px 0;" class="bg9 mobile-top">
    <div data-v-8852af17="" class="container">
      <h1 style="color: #fff; font-weight: 500;å">Privacy Policy</h1>
      <hr style="border-top: 1px solid rgba(255, 255, 255, .9);"/>
      <h5 style="color: #fff; opacity: .8;">This policy was last updated January 2024. Spacesaver Corporation (“Spacesaver”, “us” or “we”) is committed to protecting the privacy of your personal information. To that end, no information collected through this website will be sold, disclosed, distributed, or otherwise made available to third parties, other than as described below or with your prior approval.</h5>

    </div>
  </section>
  <section class="privacy-page">
  <div class="container">
    <div class="card-back">
    <!--
      <a href="/"
          type="button"
          class="btn flex-none dismiss-btn"
          style="background: #00b4b4; color: #fff; padding: 5px 10px; margin-bottom: 20px;"
          aria-label="Accept"
          @click="acceptCookies"
        >
          <span>Back to Login</span>
  </a>
    -->
  



<h4>Collecting Personal Information</h4>
<hr/>
<p>Spacesaver collects certain information from users of this site. This information includes, but is not limited to, IP addresses, referring IP addresses (i.e., search engines used to find this site), data on the pages viewed, site traveled to if the user exits this site using the Sales Office Locator, and the last page viewed on this site.</p>
<p>As you browse Spacesaver.com, advertising cookies will be placed on your computer so that we can understand what you are interested in; and this then enables us to present you with retargeting advertising on other sites based on your previous interaction with Spacesaver.com. The techniques we employ do not collect personal information such as your name, email address, postal address, or telephone number.</p>
<p>In order to better enable you to determine whether you wish to opt out of cookies, here is the cookie we use:</p>
<ul>
  <li> ◦ _secure_session_id, unique token, sessional</li>
</ul>
<p>Spacesaver also provides potential customers the opportunity to contact us via the “Download” or “Contact Us” form. Users freely provide Spacesaver with product requests and other information through these forms. Submitting this form is not necessary for entry or access into any area of the site.</p>
<p>Spacesaver collects and maintains all submitted information. </p>
<br/>
<h4>Use of Personal Information</h4>
<hr>
<p>All information collected or provided through this site will only be used by Spacesaver, its authorized Area Contractors, and others directly associated with Spacesaver. Only visitors providing Spacesaver with information via the “Download” or “Contact Us” forms will be contacted. </p>
<br/>
<h6>Disclosure</h6>
<p>Spacesaver may disclose any information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on Spacesaver or this site; (b) protect and defend the rights or property of Spacesaver and its sites; and/or (c) protect the personal safety of customers of Spacesaver or the public. </p>
<br/>
<h4>Consent</h4>
<hr>
<h6>How does Spacesaver get my consent?</h6>
<p>When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, you are deemed to have consented to our collection and retention of the information provided, our use of the information in order to perform the task you requested and our disclosure of such information to third parties Spacesaver reasonably determines necessary in order to perform the requested task.</p>
<p>Unless you ask us not to, we may also contact you via email in the future to tell you about specials, new products or services, or changes to this privacy policy. </p>

<h6>How do I withdraw my consent?</h6>
<p>You may withdraw your consent for us to contact you for the continued collection, use or disclosure of your information, at any time, by written instruction sent to <a href="mailto:spacesavermktg@spacesaver.com">spacesavermktg@spacesaver.com</a> or by mail at: Spacesaver Corporation, 1450 Janesville Ave., Fort Atkinson, Wisconsin US 53538 </p>
<br/>
  <h4>Third-Party Services</h4>
<hr>
<p>In general, third-party service providers we use will only collect, use or disclose your information to the extent necessary to allow them to perform the services they provide to us.</p>
<p>However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions.</p>
<p>For these providers, we recommend you read their privacy policies so you can understand the way your personal information will be handled by these providers.</p>
<p>Remember that certain providers may be located in or have facilities located a different jurisdiction than either you or us. So, if you elect to proceed with a transaction that involves the services of a third-party service provider, your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.</p>
<p>As an example, if you are in Canada and your transaction is processed by a payment gateway located in the United States, your personal information used in completing that transaction may be subject to disclosure under United States legislation, including the Patriot Act.</p>
<p>Once you leave our store’s website or are redirected to a thirdparty website or application, you are no longer governed by this Privacy Policy or our website’s <a href="https://www.spacesaver.com/terms-of-service" target="_blank">Terms of Service</a>. </p>
<br/>
<h4>Links</h4>
<hr>
<p>When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements. </p>
<h4>Security of Personal Information</h4>
<hr>
<p>To protect your personal information, Spacesaver takes reasonable precautions and follows industry best practices to make sure your information is not inappropriately lost, misused, accessed, disclosed, altered or destroyed. Notwithstanding, Spacesaver cannot and does not guarantee the safety or privacy of your personal information, whether submitted to Spacesaver or collected via the mechanisms described in this Privacy Policy. If you provide us with your credit card information, the information is encrypted using secure socket layer technology (SSL) and stored with a AES-256 encryption. Although no method of transmission over the Internet or electronic storage is 100% secure, we follow all PCI-DSS requirements and implement additional generally accepted industry standards. </p>
<br/>
<h4>Changes to this Policy</h4>
<hr>
<p>Spacesaver will occasionally update this Privacy Policy. The “last updated” date at the top of this Privacy Policy will change to reflect such updates. Any changes to this Privacy Policy will apply to data collected after such changes have been made. Spacesaver reserves the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website with the “last updated” date at the top of the page. </p>
<br/>
<h4>Contact Information</h4>
<hr>
<p>Question or Comments regarding this Privacy Policy can be directed to <a href="mailto:spacesavermktg@spacesaver.com;">spacesavermktg@spacesaver.com</a> or by mail to Spacesaver Corporation, 1450 Janesville Avenue, Fort Atkinson, Wisconsin 53538 USA</p>
<div style="display: flex;">
<a href="/"
          type="button"
          class="btn flex-none dismiss-btn"
          style="background: #00b4b4; color: #fff; padding: 5px 10px; margin-top: 10px; margin-left: auto;"
          aria-label="Accept"
          @click="acceptCookies"
        >
          <span>Back to Login</span>
  </a>  
  </div>
</div>
  </div>
  </section>
  </div>
</template>

<script>
//import XMarkIcon from '@heroicons/vue/20/solid'

export default {
  name: "PrivacyPolicy",
      data() {
      return {

      };
  },
}
</script>

<style scoped>
.privacy-page {
  padding: 50px 0 100px;
  background-color: #DDE3EA;
  background-color: #EEF4F7;
  /*
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cg stroke='%23D8DEE5' stroke-width='0' stroke-miterlimit='99' %3E%3Cpolygon fill='%23E2E8F0' points='-70 85 100 0 0 150 200 0 0 300 350 0 0 500 550 0 0 750 800 0 0 1050 1100 0 0 1400 1450 0 0 1850 1950 0 1000 3000 -99 3000'/%3E%3C/g%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
    */
}
.privacy-page a {
  color: #00b4b4;
}
.card-back{
  background: #fff;
  padding: 40px;
  border-radius: 6px;
}
</style>
